var ENGINE = ENGINE || {};

/**
 * 状態管理
 *
*/
ENGINE.store = ENGINE.store || {};

ENGINE.store.navigationOpend     = false;
ENGINE.store.navigationAnimation = false;

ENGINE.store.$body = $('body');


/**
 * bodyのスクロールを固定する
 *
*/
ENGINE.freeze = {
  
  init: function() {

    if(this.initialized) return false;

    this.initialized = true,
    this.position    = false;
    this.$window     = $(window);
    this.$body       = $('body');
  },

  set: function() {
    this.init();

    this.position = this.$window.scrollTop();
    this.$body
    .addClass('is-BodyFreeze')
    .css({
      position: 'fixed',
      width: '100%',
      height: '100%',
      overflowX: 'hidden',
      overflowY: 'scroll',
      top: Math.abs(this.position) * -1
    });
  },

  unset: function() {
    this.init();

    if(this.position === false) return false;
    this.$body
    .removeClass('is-BodyFreeze')
    .css({
      position: '',
      width: '',
      height: '',
      overflowX: '',
      overflowY: '',
      top: ''
    });

    this.$window.scrollTop(Math.abs(this.position));
    this.position = false;
  },
};


/**
 * オブジェクトの監視
 *
*/
ENGINE.smoothScroll = {
  init: function() {
    var container = $('#u-MainConatiner');
    var $anchor = $('a[href^="#"]', container);

    console.log($anchor);

    $anchor.on('click', function(e) {
      e.preventDefault();

      var href = $(this).attr('href');

      var $target = $(href);

      if(!$target.length) return false;
      
      $target.velocity('scroll');
    });
  },
};


/**
 * オブジェクトの監視
 *
*/
ENGINE.effect = {
  init: function() {
    const options = {
      rootMargin: '-10% 0%'

      // threshold: 0.5,
      // threshold: [0, 0.2, 0.4, 0.6, 0.8, 1.0],
      // threshold: [0, 0.5],
    };

    const callback = function(entries, observer) {
      entries.forEach(entry => {
        const el = entry.target;

        if(entry.intersectionRatio) {
          // ready状態のターゲットであればアニメーション実行用のクラスを付与する
          // if(el.classList.contains('ready')) {
          // }
          el.classList.add('is-State--Entry');

          // 一度画面内に現れた要素は監視を終了
          observer.unobserve(el);
        } else {

          // 初回発火時に画面外に要素にはアニメーション準備のクラスを付与する
          // el.classList.add('ready');
        }
      });
    }

    this.observer = new IntersectionObserver(callback, options);
    const node = document.querySelectorAll('.js-Effect');
    this.elements = Array.prototype.slice.call(node);
    this.start();
  },

  start: function() {
    this.elements.forEach(el => this.observer.observe(el));
  },

  stop: function() {
    this.elements.forEach(el => this.observer.unobserve(el));

  }
}


/**
 * ナビゲーションの開閉
 */
ENGINE.navigation = {
  init: function() {
    this.$btn = $('#l-NavigationButton');
    this.$navigation = $('#l-Navigation');
    this.$menu = $('.l-Navigation__MenuButton', this.$navigation);

    this.$navigation.on('animationend', this.removeClass.bind(this));

    this.$btn.on('click', $.proxy(function() {

      if(this.isAnimation) return false;

      this.isAnimation = true;

      if(this.$btn.hasClass('is-State--Active')) {
        // leave
        this.close();
        
      } else {
        // enter
        this.open();

      }
    
    },this));


    // メニューをクリックしたときの動作
    this.$menu.on('click', $.proxy(function(e){
      e.preventDefault();

      var $this = $(e.currentTarget);
      var href = $this.attr('href');
      this.close();
      
      const $target = $(href);
      $target.velocity('scroll');
    }, this));
  },

  open: function() {
    this.$btn.addClass('is-State--Active');
    this.$navigation.addClass('is-State--Active is-Animation--Enter');
    ENGINE.freeze.set();
  },
  
  close: function() {
    this.$btn.removeClass('is-State--Active');
    this.$navigation.addClass('is-Animation--Leave');
    ENGINE.freeze.unset();
  },

  removeClass: function() {
    if(this.$navigation.hasClass('is-Animation--Enter')) {
      this.$navigation.removeClass('is-Animation--Enter');
      
    } else if(this.$navigation.hasClass('is-Animation--Leave')) {
      this.$navigation.removeClass('is-Animation--Leave is-State--Active');
      
    }

    this.isAnimation = false;
  }
}


/**
 * 社員紹介のアコーディオン
 */
ENGINE.staff = {
  init: function() {
    this.$toggleButtons = $('.js-InerviewAccordion--Toggle');
    this.$targets = $('.js-InerviewAccordion--Target');
    this.$closeButtons = $('.js-InerviewAccordion--Close');

    this.$toggleButtons.on('click', $.proxy(function(e) {
      var $this = $(e.currentTarget);
      var accordion = $this.data('accordion');
      var $target = this.$targets.filter('[data-accordion="' + accordion + '"]');

      if( $this.hasClass('is-State--Active') ) {
        $this.removeClass('is-State--Active');
        $target.velocity('slideUp');
        
      } else {
        $this.addClass('is-State--Active');
        $target.velocity('slideDown');
      }
    }, this));

    this.$closeButtons.on('click', $.proxy(function(e) {
      var $this = $(e.currentTarget);
      var accordion = $this.data('accordion');
      var $button = this.$toggleButtons.filter('[data-accordion="' + accordion + '"]');
      var $target = this.$targets.filter('[data-accordion="' + accordion + '"]');

      $button.removeClass('is-State--Active');
      $target.velocity('slideUp');

    }, this));
  }
}


/**
 * ガイドラインのアコーディオン
 */
ENGINE.guideline = {
  init: function() {
    this.$buttons = $('.js-GuidelineAccordion--Button');
    this.$closes = $('.js-GuidelineAccordion--Close');

    this.mq = window.matchMedia('(max-width: 768px)');

    this.mq.addListener($.proxy(function(e) {
      if(e.matches) {

      } else {
        this.reset();        
      }
    }, this));

    this.$buttons.on('click', $.proxy(function(e) {
      var $this = $(e.currentTarget);

      if(!this.mq.matches) return false;
      
      if($this.hasClass('is-State--Active')) {
        $this.removeClass('is-State--Active')
        $this.next().velocity('slideUp');
        
      } else {
        $this.addClass('is-State--Active')
        $this.next().velocity('slideDown');

      }

    }, this));


    this.$closes.on('click', $.proxy(function(e) {
      var $this = $(e.currentTarget);

      var accordion = $this.data('accordion');

      var button = this.$buttons.filter('[data-accordion="' + accordion + '"]');

      button.removeClass('is-State--Active');
      button.next().velocity('slideUp');

    }, this));
  },

  reset: function() {
    this.$buttons.removeClass('is-State--Active');
    this.$buttons.next().css({display: ''});
  }
}


ENGINE.mainvisual = {
  init: function() {
    var option = {
      rootMargin: '0% 0% -100% 0%'
    }

    this.mainContainer = document.getElementById('u-MainConatiner');
    this.mainvisual = document.getElementById('u-Mainvisual');
    this.copy = document.getElementById('u-MainvisualCopy');

    this.setHeight();
    this.slider();

    // メインビジュアルが画面外の場合にスライダーを非表示
    this.observer = new IntersectionObserver(this.callback.bind(this), option);
    this.observer.observe(this.mainContainer); 
    
    window.addEventListener('resize', () => {
      this.setHeight();
    }, false);
  },
  
  setHeight: function() {

    // $(this.debug).html(`
    //   【window.innerHeight】${window.innerHeight}<br>
    //   【$(window).height()】${$(window).height()}<br>
    //   【screen.availHeight】${screen.availHeight}<br>
    //   【screen.height】${screen.height}<br>
    //   【window.innerHeight】${window.innerHeight}<br>
    //   【window.outerHeight】${window.outerHeight}<br>
    //   【document.documentElement.clientHeight】${document.documentElement.clientHeight}
    //   【$(document).height()】${$(document).height()}
    // `);

    this.mainvisual.style.height = `${screen.height}px`; 
    this.mainContainer.style.marginTop = `${screen.height}px`; 
  },

  callback: function(entries) {
    for(var entry of entries) {
      if(entry.isIntersecting) {
        // this.swiper.autoplay.stop();
        this.mainvisual.classList.add('is-Visivility--Hidden');
        this.copy.classList.add('is-Visivility--Hidden');
        
      } else {
        // this.swiper.autoplay.start();
        // this.restart();
        this.mainvisual.classList.remove('is-Visivility--Hidden');
        this.copy.classList.remove('is-Visivility--Hidden');
      }
    }
  },

  slider: function() {
    this.container     = this.mainvisual.querySelector('.swiper-container');

    this.swiper = new Swiper(this.container, {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        waitForTransition: false
      },
      speed: 1000,
      simulateTouch: false,
      watchOverflow: true,
    });

    // window.addEventListener('blur', this.restart.bind(this));

    window.addEventListener('focus', this.restart.bind(this));

    // window.addEventListener('focus', () => {console.log('active');});
  },
  
  restart: function() {
    // this.swiper.update();
    // this.swiper.slideNext(0, false);
    // this.swiper.autoplay.start();
    
    this.swiper.init();
    // this.swiper.slideNext(1000, false);
    // console.log(this.swiper.autoplay.running);
  }
}


ENGINE.office = {
  init: function() {
    const items = document.querySelectorAll('.js-OfficeSlider');
    this.itemArray = Array.from(items);

    if(!this.itemArray.length) return false;

    this.itemArray.forEach($.proxy(function(item) {
      new this.slider(item);
    }, this));
  },

  slider: function(item) {

    this.wrapper    = item;
    this.slider     = this.wrapper.querySelector('.swiper-container');
    this.pagination = this.wrapper.querySelector('.u-OfficeSlider__Pagination');
    this.prev       = this.wrapper.querySelector('.u-OfficeSlider__Prev');
    this.next       = this.wrapper.querySelector('.u-OfficeSlider__Next');

    this.swiper = new Swiper(this.slider, {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 2,
      autoplay: false,
      speed: 300,
      
      // simulateTouch: false,
      watchOverflow: true,
      
      navigation: {
        nextEl: this.next,
        prevEl: this.prev,
      },
      
      pagination: {
        el: this.pagination,
        // el: 'u-OfficeSlider__Pagination',
        type: 'bullets',
        bulletClass: 'u-OfficeSlider__PaginationBullet',
        bulletActiveClass: 'is-State--Active',
      },

      breakpoints: {
        1441: {
          slidesPerView: 3,
        },
      }
    });
  }
}



/**
* 発火用
*/
window.addEventListener('DOMContentLoaded', function() {

  ENGINE.effect.init();

  ENGINE.smoothScroll.init();

  ENGINE.navigation.init();

  ENGINE.staff.init();
  
  ENGINE.guideline.init();

  ENGINE.mainvisual.init();

  ENGINE.office.init();

});